import { useState } from "react";
import { API } from "./api";
import { TextField, Button, Grid, MenuItem, Card, CardContent, Typography } from "@mui/material";

export default function AddApp() {
  const [form, setForm] = useState({
    app_name: "",
    client: "",
    module: "",
    environment: "",
    repo_name: "",
    developer: "",
    url: "",
    cloud: "",
    server_name: "",
    jenkins_pipeline: ""
  });

  const [message, setMessage] = useState("");

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const submit = async () => {
    try {
      // ✅ Basic validation
      if (!form.app_name || !form.url || !form.environment) {
        setMessage("❌ Please fill required fields (App Name, URL, Environment)");
        return;
      }

      await API.post("/apps", form);

      // ✅ Success message
      setMessage("✅ Application added successfully");

      // ✅ Reset form
      setForm({
        app_name: "",
        module: "",
        environment: "",
        repo_name: "",
        developer: "",
        url: "",
        cloud: "",
        server_name: "",
        jenkins_pipeline: ""
      });

      setTimeout(() => setMessage(""), 2000);

    } catch (err) {
      setMessage("❌ Failed to add application (check login/token)");
    }
  };

  return (
    <div>

      {/* ✅ MESSAGE */}
      {message && (
        <div style={{
          background: message.includes("❌") ? "#f8d7da" : "#d4edda",
          color: message.includes("❌") ? "#721c24" : "#155724",
          padding: "10px",
          borderRadius: "6px",
          marginBottom: "15px"
        }}>
          {message}
        </div>
      )}

      <Card style={{ maxWidth: 600, margin: "auto", padding: 10 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            ➕ Add New Application
          </Typography>

          <Grid container spacing={2}>

            <Grid item xs={12}>
              <TextField fullWidth label="Application Name"
                value={form.app_name}
                onChange={(e) => handleChange("app_name", e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Client"
                value={form.client}
                onChange={(e) => handleChange("client", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Module"
                value={form.module}
                onChange={(e) => handleChange("module", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label="Environment"
                value={form.environment}
                onChange={(e) => handleChange("environment", e.target.value)}
              >
                {["DEV", "UAT", "PROD", "DEMO", "POC"].map(e => (
                  <MenuItem key={e} value={e}>{e}</MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Repo Name"
                value={form.repo_name}
                onChange={(e) => handleChange("repo_name", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Developer"
                value={form.developer}
                onChange={(e) => handleChange("developer", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="URL"
                value={form.url}
                onChange={(e) => handleChange("url", e.target.value)} />
            </Grid>

            {/* ✅ FIXED: Cloud is now manual input */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Cloud"
                value={form.cloud}
                onChange={(e) => handleChange("cloud", e.target.value)}
                placeholder="Enter Cloud (AWS / Azure / etc)"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Server Name"
                value={form.server_name}
                onChange={(e) => handleChange("server_name", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Jenkins Pipeline Path"
                value={form.jenkins_pipeline}
                onChange={(e) => handleChange("jenkins_pipeline", e.target.value)} />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                onClick={submit}
              >
                Add Application
              </Button>
            </Grid>

          </Grid>
        </CardContent>
      </Card>

    </div>
  );
}